import { render, staticRenderFns } from "./aoc.vue?vue&type=template&id=3c89deae&scoped=true&"
import script from "./aoc.vue?vue&type=script&lang=js&"
export * from "./aoc.vue?vue&type=script&lang=js&"
import style0 from "./aoc.vue?vue&type=style&index=0&id=3c89deae&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c89deae",
  null
  
)

export default component.exports